import { LandingPageBase } from '../landing-page-base/landing-page-base.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.css'],
    standalone: true,
    imports: [MatCardModule, MatButtonModule, CommonModule, LandingPageBase]
})
export class Error {
    headerText: string = 'Error';
    contentText: string = 'An unknown error occurred.';
    constructor(private route: ActivatedRoute) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.headerText = params['headerText'] || this.headerText; 
            this.contentText = params['contentText'] || this.contentText; 
        });
    }
}
